import { useState } from "react";
import useAxios from "axios-hooks";
import DeleteConfirmationDialog from "../../../Util/DeleteConfirmationDialog";

const DeleteActionItemModal = ({
  showModal,
  toggleShowModal,
  onDelete,
  actionItemId,
  actionItemTitle,
}) => {
  const [errorMessage, setErrorMessage] = useState("");
  const [{ loading }, executeDelete] = useAxios(
    {
      method: "delete",
      url: `action-item/${actionItemId}/`,
    },
    { manual: true }
  );

  const handleDelete = async () => {
    try {
      const response = await executeDelete({ data: {} });
      if (response?.status >= 200 && response?.status < 300) {
        setErrorMessage("");
        onDelete?.();
        toggleShowModal();
        return true;
      }
    } catch (error) {
      const firstError = Array.isArray(error?.response?.data?.errors)
        ? error.response.data.errors[0]
        : null;
        
      const apiMessage =
        (typeof error?.response?.data?.message === "string"
          ? error.response.data.message
          : null) ||
        (typeof firstError === "string"
          ? firstError
          : typeof firstError?.errorMessage === "string"
          ? firstError.errorMessage
          : typeof firstError?.message === "string"
          ? firstError.message
          : typeof firstError?.propertyName === "string"
          ? firstError.propertyName
          : null) ||
        (typeof error?.response?.data === "string"
          ? error.response.data
          : null) ||
        error?.message;

      setErrorMessage(
        apiMessage ||
          "Unable to delete this action item. Please ensure it is not in use and try again."
      );
    }

    return false;
  };

  return (
    <DeleteConfirmationDialog
      isVisible={showModal}
      onDismiss={() => {
        setErrorMessage("");
        toggleShowModal();
      }}
      onConfirm={handleDelete}
      resourceName={actionItemTitle}
      resourceType="action item"
      confirmationValue={actionItemTitle || "delete"}
      isDeleting={loading}
      errorMessage={errorMessage}
    />
  );
};

export default DeleteActionItemModal;